// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__18aT9","footer":"ReportModalFilter_footer__1fei5"};